/* eslint-disable no-unused-vars */
import React, { Suspense, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import {LOGIN,CPLOGIN,CPLOGINTOKEN,LENDERSIGNUP,BORROWERSIGNUP,SALESLOGIN,REGISTER,SIGNUP}from "../../../constants/routes";
import { getItem } from "../../../utilities/authUtils";
import { useSelector } from "react-redux";
import Loader from "../../elements/loader";

// Lazy Loaded Pages
const Login = React.lazy(() => import("../login/Login"));
const CPLogin = React.lazy(() => import("../CPPartner/CPLogin"));
const Register = React.lazy(() => import("../login/Register"));
const Signup = React.lazy(() => import("../login/Signup"));
const SalesLogin = React.lazy(() => import("../sales/SalesLogin"));
const NotFound = React.lazy(() => import("../NotFound"));

// Lazy Loaded Route Groups
const BorrowerRoutes = React.lazy(() => import("./BorrowerRoutes"));
const InvestorRoutes = React.lazy(() => import("./InvestorRoutes"));
const AdminRoutes = React.lazy(() => import("./AdminRoutes"));
const SalesRoutes = React.lazy(() => import("./SalesRoutes"));
const CPRoutes = React.lazy(() => import("./CPRoutes"));
const RecoveryRoutes = React.lazy(() => import("./RecoveryRoutes"));

const AppRoutes = () => {
  const authState = useSelector((state) => state.authState);

  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const idToken = getItem("id_token");

    if (!idToken) {
      setUserRole(null);
      return;
    }

    // Dynamic import for smaller initial bundle
    import("jwt-decode")
      .then(({ default: decode }) => {
        const decodedToken = decode(idToken);
        setUserRole(decodedToken);
      })
      .catch((error) => {
        console.error("JWT Decode Error:", error);
        setUserRole(null);
      });
  }, [authState]);

  const PrivateRouteWithoutLogin = ({
    component: Component,
    ...rest
  }) => {
    const reqId = getItem("req_id");

    return (
      <Route
        {...rest}
        render={(props) =>
          reqId ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname:LOGIN,
              }}
            />
          )
        }
      />
    );
  };

  return (
    <Suspense fallback={<Loader/>}>
      <Switch>
        {/* Default Route */}
        <Redirect
          from="/"
          exact
          to={{ pathname: LOGIN }}
        />

        {/* Public Routes */}
        <Route
          exact
          path={LOGIN}
          component={Login}
        />

        <Route
          exact
          path={CPLOGIN}
          component={CPLogin}
        />

        <Route
          exact
          path={CPLOGINTOKEN}
          component={Login}
        />

        <Route
          exact
          path={SALESLOGIN}
          component={SalesLogin}
        />

        {/* Register / Signup */}
        <PrivateRouteWithoutLogin
          exact
          path={REGISTER}
          component={Register}
        />

        <PrivateRouteWithoutLogin
          exact
          path={SIGNUP}
          component={Signup}
        />

        <PrivateRouteWithoutLogin
          exact
          path={BORROWERSIGNUP}
          component={Signup}
        />

        <PrivateRouteWithoutLogin
          exact
          path={LENDERSIGNUP}
          component={Signup}
        />

        {/* Role Based Routes */}
        {userRole && userRole?.usertype === 2 ? (
          <BorrowerRoutes />
        ) : userRole && userRole?.usertype === 3 ? (
          <InvestorRoutes />
        ) : userRole &&
          (userRole?.role === "1" ||
            userRole?.role === "5" ||
            userRole?.role === "4" ||
            userRole?.role === "6" ||
            userRole?.role === "7") ? (
          <AdminRoutes />
        ) : userRole &&
          userRole?.role === "Sales" ? (
          <SalesRoutes />
        ) : userRole &&
          userRole?.role === "channel_partner" ? (
          <CPRoutes />
        ) : userRole &&
          userRole?.role === "8" ? (
          <RecoveryRoutes />
        ) : (
          <Route path="*" component={NotFound} />
        )}
      </Switch>
    </Suspense>
  );
};

export default AppRoutes;